<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row class="margin-bottom-sm">
			<el-card>
				<el-form ref="formSearch" :model="searchData" label-width="80px" size="mini" :inline="true"
					:rules="tableRules">
					<el-form-item prop="date_range" label="当前年份">
						<el-date-picker v-model="searchData.date_range" type="year" align="right" value-format="yyyy"
							size="mini" placeholder="请选择年份" />
					</el-form-item>
					<el-form-item prop="date_range_compare" label="对比年份">
						<el-date-picker v-model="searchData.date_range_compare" type="years" value-format="yyyy"
							placeholder="选择一个或多个年份">
						</el-date-picker>
					</el-form-item>

					<el-form-item prop="area">
						<el-select v-model="searchData.area" placeholder="请选择地区" multiple collapse-tags>
							<el-option v-for="item in areaOptions" :key="item.index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="brand">
						<el-select v-model="searchData.brand" placeholder="请选择品牌" multiple collapse-tags>
							<el-option v-for="item in brandOptions" :key="item.index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitFormSearchData('formSearch')">查看报表</el-button>
						<el-button @click="resetSearchForm('formSearch')">重置</el-button>
						<el-button type="success" @click="submitExportData('formSearch')">导出</el-button>
					</el-form-item>
					<el-divider direction="vertical"></el-divider>
					<el-form-item>
						<el-checkbox v-model="quantity_checked">销量</el-checkbox>
						<el-checkbox v-model="amount_checked">订货额</el-checkbox>
					</el-form-item>
					<el-divider direction="vertical"></el-divider>
					<el-form-item label="图表风格">
						<el-select v-model="echartTheme">
							<el-option v-for="theme in themes" :key="theme.value" :label="theme.label"
								:value="theme.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>

			</el-card>
		</el-row>

		<el-row style="margin-top:10px;">
			<el-card>
				<el-table :data="tableData" style="width: 100%; " show-summary :summary-method="getSummaries" max-height="600" ref="salesTable">
					<el-table-column label="地区" prop="province" fixed width="100" />
					<el-table-column :label="tableTitle">
						<el-table-column :label="tableMenuLabel_1">
							<el-table-column v-if="quantity_checked" label="销量(个)" prop="current_sales_quantity"
								sortable width="100" />
							<el-table-column v-if="amount_checked" label="订货额(元)" prop="current_sales_amount" sortable
								width="120" />
						</el-table-column>

						<el-table-column :label="'对比：'+item.label" v-for="(item,index) in tableHeader" :key="item.label">
							<el-table-column v-if="quantity_checked" label="销量(个)" :prop="item.prop_quantity" sortable
								width="100"></el-table-column>
							<el-table-column v-if="quantity_checked" label="销量增长(个)" :prop="item.prop_increase_quantity"
								 width="120"></el-table-column>	
							<el-table-column v-if="quantity_checked" label="销量增长率(%)" :prop="item.prop_rate_quantity"
								 width="120"></el-table-column>
							<el-table-column v-if="amount_checked" label="订货额(元)" :prop="item.prop_amount" sortable
								width="120"></el-table-column>
							<el-table-column v-if="amount_checked" label="订货额增长(元)" :prop="item.prop_increase_amount"
									 width="120"></el-table-column>
							<el-table-column v-if="amount_checked" label="订货额增长率(%)" :prop="item.prop_rate_amount"
								 width="140"></el-table-column>
						</el-table-column>
					</el-table-column>
				</el-table>
			</el-card>
		</el-row>

		<el-row style="margin-top: 10px;" :gutter="15">
			<el-col :sm="24" :xs="24">
				<el-card>
					<el-tabs v-model="barChartActiveName" :key="bar_chart_quantity.series">
						<el-tab-pane label="销量" name="bar_quantity">
							<div class="plate-card"><v-chart :options="bar_chart_quantity" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
						</el-tab-pane>

						<el-tab-pane label="订货额" name="bar_amount">
							<div class="plate-card"><v-chart :options="bar_chart_amount" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>


<script>
	import ECharts from 'vue-echarts';
	export default {
		inject: ['logout'],
		data() {
			return {
				searchData: {
					area: '',
					date_range: '',
					date_range_compare: '',
					brand: '',
				},
				quantity_checked: true,
				amount_checked: true,
				tableData: [],
				tableTitle: '地区销量订货额对比',
				tableMenuLabel_1: '当前年份',
				tableHeader: [],
				tableSummary: ['合计', ],
				tableRules: {
					date_range: [{
						required: true,
						message: '请选择当前年份',
						trigger: 'change'
					}],
					date_range_compare: [{
						required: true,
						message: '请选择对比年份',
						trigger: 'change'
					}]
				},
				loading: false,
				echartTheme: 'light',
				themes: [{
						value: 'light',
						label: '默认'
					},
					{
						value: 'dark',
						label: '黑暗'
					},
					{
						value: 'shine',
						label: '闪亮'
					},
					{
						value: 'vintage',
						label: '复古'
					},
					{
						value: 'helianthus',
						label: '太阳花'
					},
					{
						value: 'tech-blue',
						label: '科技蓝'
					},
					{
						value: 'london',
						label: '伦敦'
					},
					{
						value: 'roma',
						label: '罗马'
					},
					{
						value: 'sakura',
						label: '樱花粉'
					},
					{
						value: 'fresh-cut',
						label: '鲜果切'
					}
					// 你可以继续添加其他主题
				],
				barChartActiveName: 'bar_quantity',
				areaOptions: [],
				brandOptions: [],
				bar_chart_quantity: {
					title: {
						text: '地区销量(个)',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let tooltipText = `${params[0].axisValue}<br/>`;
							let firstValue = params[0].value;
							params.forEach((item, index) => {
								const formattedValue = item.value.toLocaleString();
								const diffValue = firstValue - item.value;
								if (index == 0) {
									tooltipText +=
										`${item.marker}${item.seriesName}：${formattedValue}（个）<br/>`;
								} else {
									tooltipText +=
										`${item.marker}${item.seriesName}：${formattedValue}（个）（差值：${diffValue.toLocaleString()} 个）<br/>`;
								}

							});
							return tooltipText;
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 10,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '12%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							interval: 0,
							fontSize: '0.8rem',
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '当前时段',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: []
						},
						{
							name: '对比时段',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: []
						},

					]
				},
				bar_chart_amount: {
					title: {
						text: '地区订货额（元）',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let tooltipText = `${params[0].axisValue}<br/>`;
							let firstValue = params[0].value;
							params.forEach((item, index) => {
								const formattedValue = item.value.toLocaleString();
								const diffValue = firstValue - item.value;
								if (index == 0) {
									tooltipText +=
										`${item.marker}${item.seriesName}：${formattedValue}（元）<br/>`;
								} else {
									tooltipText +=
										`${item.marker}${item.seriesName}：${formattedValue}（元）（差值：${diffValue.toLocaleString()} 元）<br/>`;
								}

							});
							return tooltipText;
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 10,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '12%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							interval: 0,
							fontSize: '0.8rem',
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '当前时段',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: []
						},
						{
							name: '对比时段',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: []
						},

					]
				},
			};
		},
		mounted() {
			// 获取数据
			this.getAreaOptions();
			this.getBrandOptions();
		},
		created() {

		},
		watch: {
		  tableData() {
		    this.$nextTick(() => {
		      this.$refs.salesTable.doLayout();
		    });
		  },
		  tableHeader() {
		    this.$nextTick(() => {
		      this.$refs.salesTable.doLayout();
		    });
		  }
		},

		methods: {
			//				
			getSummaries() {
				return this.tableSummary;
			},
			//重置搜索表单
			resetSearchForm(formName) {
				let that = this;
				this.$refs[formName].resetFields();
				this.$refs[formName].clearValidate();
				this.searchData.date_range_compare = '';
				this.searchData.date_range = '';
			},
			//提交搜索
			submitFormSearchData(formName) {
				// console.log(this.searchData)
				let that = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						that.getTableAndChartData(that.searchData);

					} else {
						return false;
					}
				});
			},
			// 获取地区列表
			getAreaOptions() {
				let that = this;
				this.$axios
					.get('/apis/get_area_list/')
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.areaOptions = response.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 获取品牌列表
			getBrandOptions() {
				let that = this;
				this.$axios
					.get('/apim/get/brandoptions/')
					.then(function(response) {
						that.brandOptions = response.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			//获取表格及图表数据
			getTableAndChartData(queryData) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				this.$axios({
						url: '/apis/get_yearly_area_compare/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						// console.log(res)
						that.loading = false;
						if (res.data.code == '401') {
							that.logout();
						} else {
							that.tableData = res.data.tableData;
							that.tableHeader = res.data.tableHeader;
							that.tableSummary = res.data.tableSummary;

							let date_range = res.data.date_range;
							let date_range_compare = res.data.date_range_compare;
							let brand = res.data.brand;
							that.tableMenuLabel_1 = '当前：' + date_range;

							that.tableTitle = '地区销量订货额对比 - ' + brand + '品牌';
							that.bar_chart_quantity.title.text = date_range + '年对比' + date_range_compare +
								'年地区销量（个）-' + brand + '品牌';
							that.bar_chart_quantity.xAxis[0].data = res.data.xAxis_data;
							that.bar_chart_quantity.series = res.data.bar_chart_quantity_series_data;
							that.bar_chart_amount.title.text = date_range + '年对比' + date_range_compare + '年地区订货额（元）-' +
								brand + '品牌';
							that.bar_chart_amount.xAxis[0].data = res.data.xAxis_data;
							that.bar_chart_amount.series = res.data.bar_chart_amount_series_data;

						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},

			//提交导出数据
			submitExportData(formName) {
				// console.log(this.searchData)
				let that = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						that.exportTableData(that.searchData, '按年份对比地区销量数据');

					} else {
						return false;
					}
				});
			},
			exportTableData(queryData, filename) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				};
				let fileName = filename + Date.now();

				this.$axios({
						url: '/apis/export_yearly_area_compare/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						responseType: 'blob'
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});
			}
		}
	};
</script>

<style scoped>
	.title-text {
		color: #00a6dd;
		font-size: 18px;
		font-weight: 800;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: '';
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: auto;
		margin: 0;
	}

	.echarts {
		width: 100%;
		height: 100%;
	}

	.plate-card {
		width: 100%;
		height: 350px;
		padding: 10px;
		box-sizing: border-box;
	}

	.margin-bottom-sm {
		margin-bottom: 10px;
	}
</style>